exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal---3w9Tf {\n  display: block; }\n", ""]);

// exports
exports.locals = {
	"modal": "modal---3w9Tf"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./containers/modal-container/modal-container.scss
// module id = GaDw
// module chunks = 1